import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Popover, PopoverBody } from "reactstrap";
import blackRefresh from "../../assets/images/blackRefresh.svg";
import { RootState } from "@store/index";
import { useSelector } from "react-redux";

const AmountPopoverFilter = ({
    onApply,
    minAmount,
    maxAmount,
    setMinAmount,
    setMaxAmount,
    setBtnText,
    btnText
}: {
    onApply: (min: number, max: number) => void;
    minAmount: number | "";
    maxAmount: number | "";
    setMinAmount: React.Dispatch<React.SetStateAction<number | "">>;
    setMaxAmount: React.Dispatch<React.SetStateAction<number | "">>;
    setBtnText:Function,
    btnText:string
}) => {
    const { t } = useTranslation();
    const mainColor: string = useSelector(
        (State: RootState): string => State.colorSlice.dominantColor
    );
    const [popoverOpen, setPopoverOpen] = useState(false);
   

    const toggle = () => setPopoverOpen(!popoverOpen);

    const handleApply = () => {
        const min = minAmount === "" ? 0 : minAmount;
        const max = maxAmount === "" ? Infinity : maxAmount;
        onApply(min, max);
        toggle();
    };

    const handleReset = () => {
        setMinAmount("");
        setMaxAmount("");
        onApply(0, Infinity);
        setBtnText(t("Amount"));
    };

    return (
        <div style={{ width: "110px" }}>
            <button
                id="amount-filter-popover"
                type="button"
                className="filter-button"
                onClick={toggle}
                style={{
                    width: "150px",
                    color: mainColor,
                    borderColor: mainColor,
                }}
            >
                {btnText}
            </button>

            <Popover
                placement="bottom"
                isOpen={popoverOpen}
                target="amount-filter-popover"
                toggle={toggle}
                trigger="legacy"
            >
                <PopoverBody>
                    <div style={{ padding: "10px", minWidth: "200px" }}>
                        <div
                            style={{ fontWeight: "bold", marginBottom: "10px" }}
                        >
                            Montant entre
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "8px",
                                marginBottom: "10px",
                            }}
                        >
                            <input
                                type="number"
                                value={minAmount}
                                onChange={(e) =>
                                    setMinAmount(
                                        e.target.value === ""
                                            ? ""
                                            : parseFloat(e.target.value)
                                    )
                                }
                                placeholder="Min"
                                style={{ width: "100px", padding: "5px" }}
                            />
                            <span>et</span>
                            <input
                                type="number"
                                value={maxAmount}
                                onChange={(e) =>
                                    setMaxAmount(
                                        e.target.value === ""
                                            ? ""
                                            : parseFloat(e.target.value)
                                    )
                                }
                                placeholder="Max"
                                style={{ width: "100px", padding: "5px" }}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "20px",
                            }}
                        >
                            <button
                                onClick={handleReset}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                }}
                            >
                                <img
                                    src={blackRefresh}
                                    height={18}
                                    width={18}
                                    alt="refresh CSV"
                                    style={{
                                        mixBlendMode: "normal",
                                    }}
                                />
                            </button>
                            <button
                                onClick={() => {
                                    handleApply();
                                    setBtnText(
                                        `Montant: ${minAmount}-${maxAmount}`
                                    );
                                }}
                                style={{
                                    backgroundColor: mainColor,
                                    color: "white",
                                    padding: "5px 10px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                Appliquer
                            </button>
                        </div>
                    </div>
                </PopoverBody>
            </Popover>
        </div>
    );
};

export default AmountPopoverFilter;
